// This import cannot be shortened without creating circular dependencies.
import { TrustedResponseNodeModelForm } from '@app/page-components/app/canvas/node-forms';
import {
  DesignModuleNodeProps,
  TrustedResponseObjectConfig,
  IconClass,
  NodeTypeName
} from '@app/types';
import BaseNodeModel from '../BaseNodeModel';

/** Retrieval-augmented generation node. */
export class TrustedResponseNodeModel extends BaseNodeModel<TrustedResponseObjectConfig> {
  constructor(
    nodeName = 'UNTITLED_NODE',
    x = 0,
    y = 0,
    props: DesignModuleNodeProps<TrustedResponseObjectConfig> | null = null,
    id = null
  ) {
    super(nodeName, x, y, null, id);
    this.props.nodeTypeName = NodeTypeName.trustedResponse;
    this.props.iconClass = IconClass.book;
    this.props.colorClass = 'goldenrod';
    this.applyProps(props);
  }

  getConfigViews() {
    return [
      <TrustedResponseNodeModelForm key="form" object={this} />
    ];
  }
}
